// Universal language system for AI Sales Brain (en / cn / bi).
import { createContext, useContext } from "react";

export const LangCtx = createContext("cn");
export const useLang = () => useContext(LangCtx);

// UI labels: en | cn | "en · cn"
export const tt = (lang, en, cn) => (lang === "en" ? en : lang === "cn" ? cn : `${en} · ${cn}`);

const hasCJK = (s) => /[\u4e00-\u9fff]/.test(s || "");
// Strict EN mode: strip CJK chars + fullwidth punctuation
export const enOnly = (s) => typeof s === "string"
    ? s.replace(/[\u3000-\u303f\u3400-\u4dbf\u4e00-\u9fff\uff01-\uff5e]+/g, " ").replace(/\s{2,}/g, " ").trim()
    : s;
// AI sometimes swaps en/cn fields — detect and correct for strict language purity
function pickLang(en, zh) {
    let e = en || "", z = zh || "";
    if (hasCJK(e) && z && !hasCJK(z)) { const t = e; e = z; z = t; }
    return [e, z];
}

// content fields obj.{key}_en / obj.{key}_cn — bi renders stacked
export function cx(lang, obj, key) {
    const [en, zh] = pickLang(obj?.[`${key}_en`], obj?.[`${key}_cn`]);
    if (lang === "en") return enOnly(en || zh);
    if (lang === "cn") return zh || en;
    if (en && zh && en !== zh) return <span>{en}<span className="block opacity-75 mt-0.5">{zh}</span></span>;
    return en || zh;
}

// list item {en, cn}
export function li(lang, x) {
    const [en, zh] = pickLang(x?.en, x?.cn);
    if (lang === "en") return enOnly(en || zh);
    if (lang === "cn") return zh || en;
    if (en && zh && en !== zh) return <span>{en}<span className="block opacity-75 mt-0.5">{zh}</span></span>;
    return en || zh;
}

export const liAll = (lang, arr) => (arr || []).map((x) => li(lang, x));
